import React from "react";

function SimulationColumn({ simulationTitle, simulationLabels, debugLayout = false }) {
  return (
    <table style={debugLayout ? { border: "1px solid #ddd" } : {}} border={debugLayout ? 1 : 0}>
      <tbody>
        <tr>
          <td
            style={{
              textAlign: "center",
              paddingLeft: "0px",
              paddingTop: "0px",
              paddingBottom: "0px",
            }}
          >
            <h5
              style={{
                textAlign: "center",
                margin: "4px",
              }}
            >
              <b>{simulationTitle}</b>
            </h5>
          </td>
        </tr>
        <tr style={{ height: "100%" }}>
          <td
            style={{
              textAlign: "center",
              paddingLeft: "0px",
              paddingTop: "0px",
              paddingBottom: "0px",
            }}
          >
            <table
              border={0}
              style={{
                width: "100%",
              }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      verticalAlign: "center",
                    }}
                  >
                    {simulationLabels[0]} {simulationLabels[1]}
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      verticalAlign: "center",
                    }}
                  />
                </tr>
                <tr>
                  <td>
                    {simulationLabels[2]} {simulationLabels[3]}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default SimulationColumn;
